<script setup>
import { RangeCalendarGridBody } from 'reka-ui';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
});
</script>

<template>
    <RangeCalendarGridBody v-bind="props">
        <slot />
    </RangeCalendarGridBody>
</template>
